import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "./Products.css";
import { FaPlus } from "react-icons/fa";
import Header from "../Components/Header";
import axios from "axios";
import BASE_URL from "../config";


const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // GET PRODUCTS
  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/Products`);

      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // DELETE PRODUCT
  const handleDelete = async (id) => {

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this product?"
    );

    if (!confirmDelete) return;

    try {

      await axios.delete(
        `${BASE_URL}/Products/${id}`
      );

      setProducts((prev) =>
        prev.filter((item) => item.id !== id)
      );

      alert("Product deleted successfully");

    } catch (error) {

      console.error(error);

      alert("Failed to delete product");
    }
  };

  return (
    <div className="products-container">
      <Header />

      <div className="products-header">
        <div>
          <h2>Products</h2>
          <p>Manage your product catalog</p>
        </div>

        <button
          className="add-btn"
          onClick={() => navigate("/add-product")}
        >
          <FaPlus /> Add Product
        </button>
      </div>

      <div className="table-box">
        <table>
          <thead>
            <tr>
              <th>Product</th>
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : products.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No Products Found
                </td>
              </tr>
            ) : (
              products.map((item) => (
                <tr key={item.id}>
                  <td className="product-cell">
                    <img
                      src={
                        item.thumbnail ||
                        "https://dummyimage.com/80x80/cccccc/000000&text=No+Image"
                      }
                      alt="product"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/product-details/${item.id}`)
                      }
                    />

                    <span>{item.product}</span>
                  </td>

                  <td className="light-text">
                    {item.category || "-"}
                  </td>

                  <td className="bold-text">
                    ₹{item.finalPrice} / ₹ {Number(item.originalPrice)}
                  </td>

                  <td
                    className={
                      item.quantity === 0
                        ? "stock red"
                        : "stock bold-text"
                    }
                  >
                    {item.stock}
                  </td>

                  <td>
                    <span
                      className={
                        item.status === "Active"
                          ? "status active"
                          : "status out"
                      }
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div className="actions">

                      {/* EDIT */}
                      <div
                        className="icon-btn edit"
                        onClick={() =>
                          navigate(`/edit-product/${item.id}`)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="20px"
                          viewBox="0 -960 960 960"
                          width="20px"
                          fill="#4B77D1"
                        >
                          <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
                        </svg>
                      </div>

                      {/* DELETE */}
                      <div
                        className="icon-btn delete"
                        onClick={() => handleDelete(item.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="20px"
                          viewBox="0 -960 960 960"
                          width="20px"
                          fill="#EA3323"
                        >
                          <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
                        </svg>
                      </div>

                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Products;